import React from "react";
import DocumentList from "./DocumentList";

const Presentasjoner: React.FC = () => {
    return <DocumentList documentType="PRESENTASJON" />;
};

export default Presentasjoner;
